import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLAPSE_PERMISSIONS_ROLE } from "./constants";
export var es = /*#__PURE__*/_defineProperty({}, COLLAPSE_PERMISSIONS_ROLE, {
  STEP_3_TOOLS_TAG: '{{total}} permisos',
  STEP_3_TABLE_COLUMN_1: 'Herramienta',
  STEP_3_TABLE_COLUMN_2: 'Configurar y ver resultados',
  STEP_3_TABLE_COLUMN_3: 'Ver resultados',
  STEP_3_TABLE_COLUMN_4: 'Sin acceso',
  STEP_3_TABLE_NO_APPLY: 'No aplica (No es una herramienta editable)'
});